import { QuarterResult } from '../../api/models'

const parseCalendarDate = (isoDate: string): Date => {
  const [year, month, day] = isoDate.split('-').map(Number)
  return new Date(Date.UTC(year, month - 1, day))
}

const formatCalendarDate = (isoDate: string, includeYear: boolean): string =>
  parseCalendarDate(isoDate).toLocaleDateString('en-US', {
    timeZone: 'UTC',
    month: 'short',
    day: 'numeric',
    ...(includeYear ? { year: 'numeric' } : {}),
  })

export const formatQuarterDates = (quarter: QuarterResult): string => {
  const spansYears = quarter.start_date.slice(0, 4) !== quarter.end_date.slice(0, 4)
  return `${formatCalendarDate(quarter.start_date, spansYears)} – ${formatCalendarDate(quarter.end_date, spansYears)}`
}

export type KrStatus = 'met' | 'not-met' | 'in-progress'

export const krStatusOf = (quarter: QuarterResult): KrStatus => {
  if (quarter.met) return 'met'
  return quarter.is_complete ? 'not-met' : 'in-progress'
}

export const describeExcludedUsers = (quarter: QuarterResult): string | null => {
  const notes = [
    quarter.unidentified_users > 0 &&
      `${quarter.unidentified_users.toLocaleString()} users without a user record weren't counted.`,
    quarter.demo_users > 0 && `${quarter.demo_users.toLocaleString()} demo accounts weren't counted.`,
  ].filter((note): note is string => Boolean(note))
  return notes.length > 0 ? notes.join(' ') : null
}
